import { useEffect } from 'react';
import { Container } from 'react-bootstrap';
import ProfileForm from './ProfileForm';

const Registro = (props) => {
  useEffect(() => {
    document.title = 'Concursar - Registrarse';
  });
  return (
    <Container>
      <h1 className="header">Crear una cuenta</h1>
      <ProfileForm />
    </Container>
  );
};

export default Registro;
